/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTicketDto } from '../models/work-create-ticket-dto';
import { WorkDocument } from '../models/work-document';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTicket } from '../models/work-ticket';
import { WorkTicketPerformanceDto } from '../models/work-ticket-performance-dto';
import { WorkTicketStatisticsDto } from '../models/work-ticket-statistics-dto';
import { WorkTicketTopIssuesDto } from '../models/work-ticket-top-issues-dto';
import { WorkUnclassifiedTicketsDto } from '../models/work-unclassified-tickets-dto';
import { WorkUpdateTicketDto } from '../models/work-update-ticket-dto';

@Injectable({ providedIn: 'root' })
export class WorkTicketsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ticketsV2ControllerFindAllPaginated()` */
  static readonly TicketsV2ControllerFindAllPaginatedPath = '/v2/tickets';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 1000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by assignedUserId query param.
     *           <p>
     *              <b>Format: </b> filter.assignedUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assignedUserId=$not:$like:John Doe&filter.assignedUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.assignedUserId'?: Array<string>;

    /**
     * Filter by priority query param.
     *           <p>
     *              <b>Format: </b> filter.priority={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.priority=$not:$like:John Doe&filter.priority=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.priority'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$not</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>name</li>
     * <li>contact.lastName</li>
     * <li>projectId</li>
     * <li>userId</li>
     * <li>assignedUserId</li>
     * <li>calculationitemId</li>
     * <li>priority</li>
     * <li>statusId</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'name:ASC' | 'name:DESC' | 'contact.lastName:ASC' | 'contact.lastName:DESC' | 'projectId:ASC' | 'projectId:DESC' | 'userId:ASC' | 'userId:DESC' | 'assignedUserId:ASC' | 'assignedUserId:DESC' | 'calculationitemId:ASC' | 'calculationitemId:DESC' | 'priority:ASC' | 'priority:DESC' | 'statusId:ASC' | 'statusId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,remarks,contact.lastName,project.numberQualified,status.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>remarks</li>
     * <li>contact.lastName</li>
     * <li>project.numberQualified</li>
     * <li>status.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTicket>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'contactId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'assignedUserId'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.contactId', params['filter.contactId'], {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('filter.assignedUserId', params['filter.assignedUserId'], {});
      rb.query('filter.priority', params['filter.priority'], {});
      rb.query('filter.statusId', params['filter.statusId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTicket>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'contactId'?: (string | Array<string>);
        'userId'?: (string | Array<string>);
        'assignedUserId'?: (string | Array<string>);
        'priority'?: (string | Array<string>);
        'statusId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 1000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by assignedUserId query param.
     *           <p>
     *              <b>Format: </b> filter.assignedUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assignedUserId=$not:$like:John Doe&filter.assignedUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.assignedUserId'?: Array<string>;

    /**
     * Filter by priority query param.
     *           <p>
     *              <b>Format: </b> filter.priority={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.priority=$not:$like:John Doe&filter.priority=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.priority'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$not</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>name</li>
     * <li>contact.lastName</li>
     * <li>projectId</li>
     * <li>userId</li>
     * <li>assignedUserId</li>
     * <li>calculationitemId</li>
     * <li>priority</li>
     * <li>statusId</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'name:ASC' | 'name:DESC' | 'contact.lastName:ASC' | 'contact.lastName:DESC' | 'projectId:ASC' | 'projectId:DESC' | 'userId:ASC' | 'userId:DESC' | 'assignedUserId:ASC' | 'assignedUserId:DESC' | 'calculationitemId:ASC' | 'calculationitemId:DESC' | 'priority:ASC' | 'priority:DESC' | 'statusId:ASC' | 'statusId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,remarks,contact.lastName,project.numberQualified,status.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>remarks</li>
     * <li>contact.lastName</li>
     * <li>project.numberQualified</li>
     * <li>status.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTicket>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'contactId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'assignedUserId'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
}> {
    return this.ticketsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTicket>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'contactId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'assignedUserId'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTicket>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'contactId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'assignedUserId'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerCreate()` */
  static readonly TicketsV2ControllerCreatePath = '/v2/tickets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketsV2ControllerCreate$Response(
    params: {
      body: WorkCreateTicketDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketsV2ControllerCreate(
    params: {
      body: WorkCreateTicketDto
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerGetAutocompleteSuggestionsForTitle()` */
  static readonly TicketsV2ControllerGetAutocompleteSuggestionsForTitlePath = '/v2/tickets/autocomplete/{title}';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerGetAutocompleteSuggestionsForTitle()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetAutocompleteSuggestionsForTitle$Response(
    params: {
      title: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerGetAutocompleteSuggestionsForTitlePath, 'get');
    if (params) {
      rb.path('title', params.title, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerGetAutocompleteSuggestionsForTitle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetAutocompleteSuggestionsForTitle(
    params: {
      title: string;
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.ticketsV2ControllerGetAutocompleteSuggestionsForTitle$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerGetStatistics()` */
  static readonly TicketsV2ControllerGetStatisticsPath = '/v2/tickets/statistics';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerGetStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetStatistics$Response(
    params: {
      weeks: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicketStatisticsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerGetStatisticsPath, 'get');
    if (params) {
      rb.query('weeks', params.weeks, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicketStatisticsDto>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerGetStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetStatistics(
    params: {
      weeks: number;
    },
    context?: HttpContext
  ): Observable<WorkTicketStatisticsDto> {
    return this.ticketsV2ControllerGetStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicketStatisticsDto>): WorkTicketStatisticsDto => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerGetPerformance()` */
  static readonly TicketsV2ControllerGetPerformancePath = '/v2/tickets/performance';

  /**
   * Required permissions: tickets:admin, reports:performance-kundensupport
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerGetPerformance()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetPerformance$Response(
    params: {
      fromDate: string;
      toDate: string;
      userId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicketPerformanceDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerGetPerformancePath, 'get');
    if (params) {
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicketPerformanceDto>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, reports:performance-kundensupport
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerGetPerformance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetPerformance(
    params: {
      fromDate: string;
      toDate: string;
      userId?: number;
    },
    context?: HttpContext
  ): Observable<WorkTicketPerformanceDto> {
    return this.ticketsV2ControllerGetPerformance$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicketPerformanceDto>): WorkTicketPerformanceDto => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerGetTopIssues()` */
  static readonly TicketsV2ControllerGetTopIssuesPath = '/v2/tickets/top-issues';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerGetTopIssues()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetTopIssues$Response(
    params: {
      windowDays: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicketTopIssuesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerGetTopIssuesPath, 'get');
    if (params) {
      rb.query('windowDays', params.windowDays, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicketTopIssuesDto>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerGetTopIssues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetTopIssues(
    params: {
      windowDays: number;
    },
    context?: HttpContext
  ): Observable<WorkTicketTopIssuesDto> {
    return this.ticketsV2ControllerGetTopIssues$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicketTopIssuesDto>): WorkTicketTopIssuesDto => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerGetUnclassifiedTickets()` */
  static readonly TicketsV2ControllerGetUnclassifiedTicketsPath = '/v2/tickets/top-issues/unclassified';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerGetUnclassifiedTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetUnclassifiedTickets$Response(
    params: {
      windowDays: number;
      limit: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUnclassifiedTicketsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerGetUnclassifiedTicketsPath, 'get');
    if (params) {
      rb.query('windowDays', params.windowDays, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUnclassifiedTicketsDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerGetUnclassifiedTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetUnclassifiedTickets(
    params: {
      windowDays: number;
      limit: number;
    },
    context?: HttpContext
  ): Observable<WorkUnclassifiedTicketsDto> {
    return this.ticketsV2ControllerGetUnclassifiedTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUnclassifiedTicketsDto>): WorkUnclassifiedTicketsDto => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerRegenerateTopIssues()` */
  static readonly TicketsV2ControllerRegenerateTopIssuesPath = '/v2/tickets/top-issues/regenerate';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerRegenerateTopIssues()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerRegenerateTopIssues$Response(
    params: {
      windowDays: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicketTopIssuesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerRegenerateTopIssuesPath, 'post');
    if (params) {
      rb.query('windowDays', params.windowDays, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicketTopIssuesDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerRegenerateTopIssues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerRegenerateTopIssues(
    params: {
      windowDays: number;
    },
    context?: HttpContext
  ): Observable<WorkTicketTopIssuesDto> {
    return this.ticketsV2ControllerRegenerateTopIssues$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicketTopIssuesDto>): WorkTicketTopIssuesDto => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerFindOneById()` */
  static readonly TicketsV2ControllerFindOneByIdPath = '/v2/tickets/{id}';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerDelete()` */
  static readonly TicketsV2ControllerDeletePath = '/v2/tickets/{id}';

  /**
   * Required permissions: tickets:admin, tickets:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.ticketsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerUpdate()` */
  static readonly TicketsV2ControllerUpdatePath = '/v2/tickets/{id}';

  /**
   * Required permissions: tickets:admin, tickets:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTicketDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTicketDto
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerUpdateStatus()` */
  static readonly TicketsV2ControllerUpdateStatusPath = '/v2/tickets/{id}/status/{statusId}';

  /**
   * Required permissions: tickets:admin, tickets:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerUpdateStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerUpdateStatus$Response(
    params: {
      id: number;
      statusId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerUpdateStatusPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('statusId', params.statusId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerUpdateStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerUpdateStatus(
    params: {
      id: number;
      statusId: number;
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerUpdateUser()` */
  static readonly TicketsV2ControllerUpdateUserPath = '/v2/tickets/{id}/assignedUser/{assignedUserId}';

  /**
   * Required permissions: tickets:admin, tickets:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerUpdateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerUpdateUser$Response(
    params: {
      id: number;
      assignedUserId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerUpdateUserPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('assignedUserId', params.assignedUserId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerUpdateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerUpdateUser(
    params: {
      id: number;
      assignedUserId: number;
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerUpdateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerSubscribe()` */
  static readonly TicketsV2ControllerSubscribePath = '/v2/tickets/{id}/subscribers/me';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerSubscribe()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerSubscribe$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerSubscribePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerSubscribe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerSubscribe(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerSubscribe$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerUnsubscribe()` */
  static readonly TicketsV2ControllerUnsubscribePath = '/v2/tickets/{id}/subscribers/me';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerUnsubscribe()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerUnsubscribe$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerUnsubscribePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerUnsubscribe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerUnsubscribe(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerUnsubscribe$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerRemoveSubscriber()` */
  static readonly TicketsV2ControllerRemoveSubscriberPath = '/v2/tickets/{id}/subscribers/{userId}';

  /**
   * Required permissions: tickets:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerRemoveSubscriber()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerRemoveSubscriber$Response(
    params: {
      id: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicket>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerRemoveSubscriberPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicket>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerRemoveSubscriber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerRemoveSubscriber(
    params: {
      id: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<WorkTicket> {
    return this.ticketsV2ControllerRemoveSubscriber$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicket>): WorkTicket => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerGetDocumentsByTicketId()` */
  static readonly TicketsV2ControllerGetDocumentsByTicketIdPath = '/v2/tickets/{id}/documents';

  /**
   * Required permissions: tickets:read, tickets:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerGetDocumentsByTicketId()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetDocumentsByTicketId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerGetDocumentsByTicketIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: tickets:read, tickets:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerGetDocumentsByTicketId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerGetDocumentsByTicketId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.ticketsV2ControllerGetDocumentsByTicketId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerAddDocumentToTicket()` */
  static readonly TicketsV2ControllerAddDocumentToTicketPath = '/v2/tickets/{id}/documents/{documentId}';

  /**
   * Required permissions: tickets:admin, tickets:create, tickets:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerAddDocumentToTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerAddDocumentToTicket$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerAddDocumentToTicketPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:create, tickets:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerAddDocumentToTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerAddDocumentToTicket(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.ticketsV2ControllerAddDocumentToTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `ticketsV2ControllerRemoveDocumentFromTicket()` */
  static readonly TicketsV2ControllerRemoveDocumentFromTicketPath = '/v2/tickets/{id}/documents/{documentId}';

  /**
   * Required permissions: tickets:admin, tickets:delete, tickets:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketsV2ControllerRemoveDocumentFromTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerRemoveDocumentFromTicket$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketsV2Service.TicketsV2ControllerRemoveDocumentFromTicketPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:delete, tickets:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketsV2ControllerRemoveDocumentFromTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketsV2ControllerRemoveDocumentFromTicket(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.ticketsV2ControllerRemoveDocumentFromTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
